import { defaultTo, map, pipe } from 'lodash/fp'
import isEmpty from 'lodash/isEmpty'
import prettyBytes from 'pretty-bytes'

import type { TechpackReturnType, UITechpackModel } from '../techpack.types'

const attachMetadata = pipe(
  map((att: any) => {
    att.metadata = {
      fileSize: getfileSize(att?.metadata?.ContentLength),
      fileType: getDisplayContentType(att.link, att.metadata?.ContentType)
    }
    return att
  }),
  defaultTo([])
)
const setDefaults = pipe(defaultTo({ _id: '', name: '' }))

function getDisplayContentType(signedUrl: string, contentType = ''): string {
  const contentTypeDefault = defaultTo(contentType)
  const url = new URL(signedUrl)
  const pathParts = url.pathname.split('.')
  if (pathParts.length >= 1) {
    return contentTypeDefault(pathParts[pathParts.length - 1]).toUpperCase()
  }
  return contentType.toUpperCase()
}

function getfileSize(bytes: number): string {
  if (!bytes || !Number(bytes) || !Number.isFinite(bytes)) return 'Size Unavailable'
  return prettyBytes(bytes)
}

/**
 * converts a loosely typed graphQL techpack (due to library support)
 * to a strongly typed internal state object
 * @param techpack data returned from graphQL response
 */
export function mapTechpackToUITechpackModel(techpack: TechpackReturnType): UITechpackModel | null {
  if (isEmpty(techpack)) return null
  return {
    _id: techpack._id || '',
    link: techpack.link || '',
    name: techpack.name,
    attachments: attachMetadata(techpack.attachments),
    product: setDefaults(techpack?.product),
    metadata: {
      fileSize: getfileSize(Number(techpack?.metadata?.ContentLength)),
      fileType: getDisplayContentType(techpack.link || '', techpack.metadata?.ContentType || '')
    }
  }
}
